"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackendChannelsV2Requests = void 0;
const Paths_1 = require("../Paths");
const Utils_1 = require("../Utils");
const OptionsHandler_1 = require("./IndexUtils/OptionsHandler");
class BackendChannelsV2Requests {
    constructor(session, appInfo) {
        this.session = session;
        this.appInfo = appInfo;
        this.options = new OptionsHandler_1.OptionsHandler(this.appInfo);
    }
    getChannels() {
        return __awaiter(this, void 0, void 0, function* () {
            const options = {
                method: Paths_1.Methods.GET,
            };
            const endpoint = this.getRootEventEndpoint();
            const response = yield this.makeRequest(endpoint, options);
            response.forEach((channel) => {
                this.sortBuildTypes(channel);
            });
            return response;
        });
    }
    getChannelByName(name) {
        return __awaiter(this, void 0, void 0, function* () {
            const options = {
                method: Paths_1.Methods.GET,
            };
            const endpoint = this.getRootEventEndpoint({ name });
            const response = yield this.makeRequest(endpoint, options);
            return this.sortBuildTypes(response);
        });
    }
    addChannel(channelArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            const options = {
                method: Paths_1.Methods.POST,
                body: channelArgs,
            };
            const endpoint = this.getRootEventEndpoint();
            const response = yield this.makeRequest(endpoint, options);
            return this.sortBuildTypes(response);
        });
    }
    editChannel(channelName, args) {
        return __awaiter(this, void 0, void 0, function* () {
            const options = {
                method: Paths_1.Methods.POST,
                body: args,
            };
            const endpoint = this.getRootEventEndpoint({ name: channelName });
            const response = yield this.makeRequest(endpoint, options);
            return this.sortBuildTypes(response);
        });
    }
    sortBuildTypes(channel) {
        channel.buildTypes.sort();
        return channel;
    }
    makeRequest(endpoint, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = yield (0, Utils_1.buildGenericRequest)(this.session, options, this.options);
            return (0, Utils_1.wrapFetchJson)(request, endpoint);
        });
    }
    getRootEventEndpoint(opts) {
        let name;
        if (opts !== undefined) {
            name = opts.name;
        }
        return `${this.session.baseUrl}/${Paths_1.Constants.V2_CHANNELS}${name ? `/${name}` : ""}`;
    }
}
exports.BackendChannelsV2Requests = BackendChannelsV2Requests;
//# sourceMappingURL=BackendChannelsV2.js.map